import styled from 'styled-components'
import { VeroColors } from 'styles/palette'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex: 1;
`

export const Login = styled.div`
  background-color: ${VeroColors.backgroundForm};
  border-radius: 10px;
  box-shadow: 10;
  border-width: 1px;
  border-color: black;
  display: flex;
  flex-direction: column;
`
export const Header = styled.div`
  width: 100%;
  margin-top: 10px;
`

export const HeaderImg = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Img = styled.img`
  width: 100%;
  height: 60px;
  object-fit: contain;
`

export const FormContent = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 10px 30px;
  margin-bottom: 10px;
`
